module.exports = __webpack_public_path__ + "img/Categories_bg_004.e69a7b72.jpg";